import { i18n } from '../lang'
import MarketplaceService from '../api/marketplace'

export const statsColumns = [
  [
    {
      id: 'total_orders',
    },
    {
      id: 'total_items',
    },
    {
      id: 'avg_basket_size',
    },
    {
      id: 'avg_basket_price',
    },
  ],
  [
    {
      id: 'total_sales',
    },
    {
      id: 'total_sales_items',
    },
    {
      id: 'total_sales_shipping',
    },
  ],
  [
    {
      id: 'total_refunded',
    },
    {
      id: 'total_refunded_items',
    },
    {
      id: 'total_refunded_shipping',
    },
  ],
  [
    {
      id: 'top_selling_store',
    },
    {
      id: 'top_selling_store_sales',
    },
  ],
]

const goxipPlatforms = [
  { id: '', name: i18n.t('mpOrder.all') },
  { id: 'gx', name: i18n.t('mpOrder.goxip') },
  { id: 'rs', name: i18n.t('mpOrder.rewardsnap') },
]

const platforms = [
  { id: '', name: i18n.t('mpOrder.all') },
  { id: 'ios', name: i18n.t('mpOrder.ios') },
  { id: 'android', name: i18n.t('mpOrder.android') },
  { id: 'web', name: i18n.t('mpOrder.web') },
]

export const getOrderFilters = () => ([
  {
    id: 'date_range',
    label: i18n.t('mpOrder.dateRange'),
    width: 'calc(100% - 8px)',
    default: {
      label: 'This Month',
      value: 'thisMonth',
    },
  },
  {
    id: 'country',
    label: i18n.t('mpOrder.country'),
    width: 'calc(25% - 8px)',
    default: '',
    fetchList: async () => {
      const response = await MarketplaceService.getCountryList()
      return [
        { id: '', name: i18n.t('mpOrder.all') },
        ...response.data.map(({ code, name }) => ({
          id: code.toLowerCase(),
          name,
        })),
      ]
    },
  },
  {
    id: 'payment_currency',
    label: i18n.t('mpOrder.currency'),
    width: 'calc(25% - 8px)',
    default: '',
    fetchList: async () => {
      const response = await MarketplaceService.getCurrencyList()
      return [
        { id: '', name: i18n.t('mpOrder.all') },
        ...response.data.map(({ code }) => ({
          id: code,
          name: code,
        })),
      ]
    },
  },
  {
    id: 'gx_platform',
    label: i18n.t('mpOrder.goxipPlatform'),
    list: goxipPlatforms,
    width: 'calc(25% - 8px)',
    default: '',
  },
  {
    id: 'platform',
    label: i18n.t('mpOrder.platform'),
    list: platforms,
    width: 'calc(25% - 8px)',
    default: '',
  },
  {
    id: 'merchant_id',
    label: i18n.t('mpOrder.merchant'),
    width: 'calc(50% - 8px)',
    default: '',
    fetchList: async () => {
      const response = await MarketplaceService.getMerchantList()
      return [
        { id: '', name: i18n.t('mpOrder.all') },
        ...response.data,
      ]
    },
  },
  {
    id: 'order_number',
    label: i18n.t('mpOrder.orderNumber'),
    width: 'calc(50% - 8px)',
    default: '',
  },
])

export const orderTableColumns = [
  { type: 'date' },
  { type: 'platform' },
  { type: 'name' },
  { type: 'order_number' },
  { type: 'merchant' },
  { type: 'brand' },
  { type: 'product_name' },
  { type: 'item_quantity' },
  { type: 'store_currency' },
  { type: 'merchant_org_price' },
  { type: 'total_cost' },
  { type: 'unit_price' },
  { type: 'discount_percentage' },
  { type: 'discounted_unit_price' },
  { type: 'gross_sales' },
  { type: 'refunded_quantity' },
  { type: 'refunded_amount' },
  { type: 'sales_net_of_refund' },
  { type: 'shipping_cost' },
  { type: 'shipping_commissions' },
  { type: 'item_commissions' },
  { type: 'total_commissions' },
  { type: 'discount_code' },
  { type: 'subsidized_by' },
  { type: 'u1' },
  { type: 'gx_platform' },
  { type: 'markup_rate' },
  { type: 'discount_rate' },
  { type: 'country' },
  { type: 'payment_currency' },
  { type: 'conversion_rate' },
  { type: 'first_order' },
]

export const orderDetailFields = [
  {
    id: 'order_number',
  },
  {
    id: 'merchant',
  },
  {
    id: 'member',
  },
  {
    id: 'delivery_type',
  },
  {
    id: 'delivery_method',
  },
]

export const ORDER_API_BASE_URL = `${process.env.VUE_APP_KYLO_API_BASE_URL}/orders`
